import { useState, useEffect } from "react";
import axios from "axios";

const FidelityCommon = ({ searchParams, handleInputChange, setSearchParams, flag }) => {
    const [emogList, setEmogList] = useState([]);
    const [year, setYear] = useState([]);
    const [month, setMonth] = useState([]);

    // 1. 초기 데이터 (한 번만)
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                    params: {
                        grdc: searchParams.searchGrdc,
                        loca: searchParams.searchLoca
                    }
                });
                setEmogList(response.data.emogList || []);
            } catch (error) {
                console.error('초기 데이터 로딩 오류:', error);
            }
        };
        fetchInitialData();
    }, []);

    // 2. searchType 변경 시 -> 연도(Year) 가져오기
    useEffect(() => {
        const fetchYearInfo = async () => {
            if (!searchParams.searchType) return;
            try {
                const response = await axios.get('/ptmiapi/fidelityYearInfo.do', {
                    params: { knd: searchParams.searchType }
                });
                const years = response.data.DATELISTYY || [];
                setYear(years);

                if (years.length > 0) {
                    setSearchParams(prev => ({
                        ...prev,
                        searchCheck1: years[0].STDR_YEAR // 연도 세팅
                    }));
                }
            } catch (error) {
                console.error('연도 정보 로딩 오류:', error);
            }
        };
        fetchYearInfo();
    }, [searchParams.searchType]);

    // 3. searchType 또는 searchCheck1 변경 시 -> 월(Month) 가져오기
    // 포인트: searchType만 바뀌고 연도가 그대로여도 여기서 감지해서 월 정보를 다시 가져옵니다.
    useEffect(() => {
        const fetchMonthInfo = async () => {
            if (!searchParams.searchType || !searchParams.searchCheck1) return;
            try {
                setMonth([]);
                const response = await axios.get('/ptmiapi/fidelityMonthInfo.do', {
                    params: {
                        knd: searchParams.searchType,
                        year: searchParams.searchCheck1,
                    }
                });
                const months = response.data.DATELISTMM || [];
                setMonth(months);

                if (months.length > 0) {
                    setSearchParams(prev => ({
                        ...prev,
                        searchCheck2: months[0].STDR_QU || months[0].STDR_MT // 월/분기 세팅
                    }));
                }
            } catch (error) {
                console.error('월 정보 로딩 오류:', error);
            }
        };
        fetchMonthInfo();
    }, [searchParams.searchType, searchParams.searchCheck1]); // 두 값 중 하나만 바뀌어도 실행

    useEffect(() => {
        const fetchResultInfo = async () => {
            // 모든 조건값이 있을 때만 실행
            if (!searchParams.searchType || !searchParams.searchCheck1 || !searchParams.searchCheck2) return;

            try {
                const response = await axios.get('/ptmiapi/getFidelityResultList.do', {
                    params: {
                        knd: searchParams.searchType,
                        year: searchParams.searchCheck1,
                        month: searchParams.searchCheck2,
                    }
                });
                const result = response.data.getFidelityResultList?.[0];
                if (result) {
                    setSearchParams(prev => ({
                        ...prev,
                        searchFromdate: result.BEGIN_DE,
                        searchTodate: result.END_DE,
                        searchDateCls: result.ANALS_DT,
                    }));
                }
            } catch (error) {
                console.error('결과 날짜 정보 로딩 오류:', error);
            }
        };
        fetchResultInfo();
    }, [searchParams.searchType, searchParams.searchCheck1, searchParams.searchCheck2]); // 최종 변경 감지

    useEffect(() => {
        const fetchResultInfo = async () => {
            try {
                const response = await axios.get('/ptmiapi/getFidelityResultList.do', {
                    params: {
                        knd: searchParams.searchType,
                        year: searchParams.searchCheck1,
                        month: searchParams.searchCheck2,
                    }
                });
                const result = response.data.getFidelityResultList[0] || [];
                if (result) {
                    setSearchParams(prev => ({
                        ...prev,
                        searchFromdate: result.BEGIN_DE,
                        searchTodate: result.END_DE,
                        searchDateCls: result.ANALS_DT,
                    }));
                }
            } catch (error) {
                console.error('월 정보 로딩 오류:', error);
            }
        };
        fetchResultInfo();
    }, [searchParams.searchCheck2]);

    return (
        <>
            <th>
                <select id="searchType" name="searchType" className='w-full' value={searchParams.searchType} onChange={handleInputChange}>
                    <option value="M">월별</option>
                    <option value="Q">분기별</option>
                    <option value="H">반기별</option>
                    {flag && localStorage.getItem('userauth') !== 'J003' ?
                        <option value="P">평가별</option>
                        :
                        <></>}
                </select>
            </th>
            <td>
                <select
                    id="searchCheck1"
                    name='searchCheck1'
                    value={searchParams.searchCheck1}
                    onChange={handleInputChange}>
                    {year.map(year => (
                        <option key={year.STDR_YEAR} value={year.STDR_YEAR}>
                            {year.STDR_YEAR}년
                        </option>
                    ))}
                </select>
                &nbsp;
                <select
                    id="searchCheck2"
                    name='searchCheck2'
                    value={searchParams.searchCheck2}
                    onChange={handleInputChange}>
                    {month.map(month => (
                        <option key={month.STDR_MT} value={month.STDR_QU || month.STDR_MT}>
                            {month.STDR_QU || month.STDR_MT + '월'}
                        </option>
                    ))}
                </select>
            </td>
            <th>기관명</th>
            <td>
                <select
                    name='searchGrdc'
                    className='w-full'
                    value={searchParams.searchGrdc}
                    onChange={handleInputChange}
                    disabled={localStorage.getItem("userAuth") === "J003"}
                >
                    <option value="">전체</option>
                    {emogList.map(hosp => (
                        <option key={hosp.emogcode} value={hosp.emogcode}>
                            {hosp.emogdesc}
                        </option>
                    ))}
                </select>
            </td>
        </>
    );
}

export default FidelityCommon;